import LogoColorImg from './img/Runivers-Logo-color.svg';
import TransneftLogo1Img from './img/Transneft_logo1.png';
import GeolabImg from './img/geolab.png';
import NextgisImg from './img/nextgis.png';

export const aboutShortEn = `
<div style="margin-top: 40px;"></div>
<div class="partner_logos">
<a href="https://www.runivers.ru" target="_blank"><img src="${LogoColorImg}" /></a>
<a href="https://www.transneft.ru" target="_blank"><img src="${TransneftLogo1Img}" /></a>
<a href="https://histgeo.ru/laboratory.html" target="_blank"><img src="${GeolabImg}" /></a>
<a href="https://nextgis.com" target="_blank"><img src="${NextgisImg}" /></a>
</div>
<div style="margin-top: 40px;"></div>
<P LANG="en-GB" CLASS="western" ALIGN=JUSTIFY STYLE="margin-bottom: 0.17in">
<h2>Russia’s Borders from 1462 through 2018’ Project</h2></P>
<P LANG="en-GB" CLASS="western" ALIGN=JUSTIFY STYLE="margin-bottom: 0.17in">

<SPAN LANG="en-EN"><a href="https://www.runivers.ru" target="_blank">Runivers</a>

presents ‘Russia’s Borders from 1462 through 2018’ –
a project designed in collaboration with the
<a href="https://histgeo.ru/laboratory.html" target="_blank">
Laboratory of Historical Geomatics</a> at the Institute of World History
of the Russian Academy of Sciences (RAS) and
<a href="http://nextgis.com" target="_blank">NextGIS Ltd.</a>
</SPAN></P>

<P LANG="en-GB" CLASS="western" ALIGN=JUSTIFY STYLE="margin-bottom: 0.17in">
<SPAN LANG="en-EN">
This cartographic project contains geographical information on the political borders
of the contemporary Russian Federation and its predecessor states.
An opportunity to select any year in the 1462 to 2018 time bracket is a crucial option of this map.
To choose the needed year, the users either click at the needed point on the timeline (at the bottom of the map)
or launch its step-by-step automatic rewinding or else use the + or –
icons to the right of the timeline, thus moving one year backwards or forwards.
</SPAN></P>

<P LANG="en-GB" CLASS="western" ALIGN=JUSTIFY STYLE="margin-bottom: 0.17in">
<A NAME="OLE_LINK210"></A><A NAME="OLE_LINK209"></A>
<SPAN LANG="en-EN">
The realization that the forms of a political status of lands are multiple and that,
on the other hand, this diversity should be reduced to a limited number of versions for
depiction on the map has prompted us to single out seven different statuses of the territory
of today’s Russia and its predecessors.
</SPAN></P>
<P LANG="en-GB" CLASS="western" ALIGN=JUSTIFY STYLE="margin-bottom: 0in">
<SPAN LANG="en-EN">
1) The mainland of the state.
</SPAN></P>
<P LANG="en-GB" CLASS="western" ALIGN=JUSTIFY STYLE="margin-bottom: 0in">
<SPAN LANG="en-EN">
2) A territory under protectorate, vassal allegiance or in the sphere of influence.
</SPAN></P>
<P LANG="en-EN" CLASS="western" ALIGN=JUSTIFY STYLE="margin-bottom: 0in">
3) A leased territory.
</P>
<P LANG="en-GB" CLASS="western" ALIGN=JUSTIFY STYLE="margin-bottom: 0in">
<SPAN LANG="en-EN">
4) A territory in joint possession.
</SPAN></P>
<P LANG="en-GB" CLASS="western" ALIGN=JUSTIFY STYLE="margin-bottom: 0in">
<SPAN LANG="en-EN">
5) A litigious territory.
</SPAN></P>
<P LANG="en-GB" CLASS="western" ALIGN=JUSTIFY STYLE="margin-bottom: 0.17in">

<P LANG="en-GB" CLASS="western" ALIGN=JUSTIFY STYLE="margin-bottom: 0.17in">
<A NAME="OLE_LINK222"></A><A NAME="OLE_LINK221"></A>
<SPAN LANG="en-EN">
Changes in the configuration of the border in relevant years are shown in separate polygons as: 6.
the newly acquired territories or, 7. lost territories.
These polygons have the tokens, the numbers on which correspond to positions in the list of
territorial changes found in the info bar.
Territorial changes occurred in different months of the year – sometimes in the first half of the year,
and sometime in the second half, and that is why the polygons with statuses 6 and 7 sometimes stay on
and get over to the year that followed a specified event.
</SPAN></P>
<P LANG="en-GB" CLASS="western" ALIGN=JUSTIFY STYLE="margin-bottom: 0.17in">
<SPAN LANG="en-EN">
The differentiation is reflected in popup windows,
which the users can bring up by clicking at any object inside the political borders.
The polygons are filled with four colors. One color shows the mainland of the state and the newly
incorporated lands (statuses 1 and 6); the second color marks the lands that have a certain degree
of dependence on the state (status 2); the third color brings out the leased and litigious areas or
the lands governed jointly with other countries (statuses 3 and 5).
The lost territories (status 7) are marked with the fourth color but owing to certain technology
peculiarities of the current algorithm of geometrical arrangements formation some of the lost territories
are not displayed on the map with the aid of separate polygons. A click at any polygon will call up
the information on the chronological range, in which a territorial entity existed, and on its size (in sq. km).
</SPAN></P>

<P LANG="en-GB" CLASS="western" ALIGN=JUSTIFY STYLE="margin-bottom: 0.17in">
<SPAN LANG="en-EN">
Placed in the center of each polygon is a token that helps the users find an appropriate
location on a small-scale map. A click at the token will retrieve the data on the event
that resulted in the formation of the specific territorial entity.
</SPAN></P>
<P LANG="en-GB" CLASS="western" ALIGN=JUSTIFY STYLE="margin-bottom: 0.17in">
<SPAN LANG="en-EN">
Three button icons are available in the upper right-hand corner of the map.
The first one switches the contemporary basemap off, while two others make it
possible to handle the presentation of two data units of the map.
The first unit shows the name, title/ official position and the years in office of the person
who ruled the territory in the year chosen by the user. It also contains a reference to a special page
at the website that offers detailed information. The lower data unit provides information
on the territorial changes in the selected year, as well as on an approximate size of the lands
that were incorporated into the nation or, vice versa, were lost.
</SPAN></P>
<P LANG="en-GB" CLASS="western" ALIGN=JUSTIFY STYLE="margin-bottom: 0.17in">
<SPAN LANG="en-EN">
‘The Borders of the Duchy of Muscovy/ Czardom of Russia/ Russian Empire/ USSR/
Russian Federation from 1462 through 2018’ web GIS rests on the concept of a dynamic map.
As regards the technical implementation, this concept embodies an original solution developed at the
<a href="https://histgeo.ru/laboratory.html" target="_blank">Laboratory of Historical Geomatics</a>
of the RAS Institute of World History in cooperation with
<a href="http://nextgis.com" target="_blank">NextGIS Ltd.</a>
</SPAN></P>

<P LANG="en-GB" CLASS="western" ALIGN=JUSTIFY STYLE="margin-bottom: 0.17in">
<SPAN LANG="en-EN">
Practical applicability of this project for research purposes makes it stand out among other projects of this kind.
The dynamic maps displaying the past changes of state borders most typically have an educational
focus and historians do not have a chance to amend them after expert debates.
Conversely, the dynamic map released now is open for future amendments and is called upon
to serve as an instrumental cartographic aid for the scholars of history who use GIS technologies
to attain specified research objectives.


<P LANG="en-GB" CLASS="western" ALIGN=JUSTIFY STYLE="margin-bottom: 0.17in">
<SPAN LANG="en-EN">
Technical implementation  <a href="http://nextgis.com/blog/runivers/" target="_blank">description</a>.
</SPAN></P>
`;
